"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
var _APButton = _interopRequireDefault(require("../APButton"));
var _APIcon = _interopRequireDefault(require("../APIcon"));
require("./APInlineButton.css");
var _excluded = ["icon", "text", "customClass", "iconModifier"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var baseClass = 'ap-inline-btn';
var APInlineButton = function APInlineButton(props) {
  var icon = props.icon,
    text = props.text,
    customClass = props.customClass,
    iconModifier = props.iconModifier,
    otherProps = _objectWithoutProperties(props, _excluded);
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)([baseClass, customClass]);
  return /*#__PURE__*/_react["default"].createElement(_APButton["default"], _extends({
    baseClass: baseClass,
    customClass: customClass
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: icon,
    classModifiers: iconModifier,
    customClass: bemClasses('image')
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: bemClasses('text')
  }, text));
};
APInlineButton.propTypes = {
  icon: _propTypes["default"].string.isRequired,
  iconModifier: _propTypes["default"].string,
  text: _propTypes["default"].string,
  customClass: _propTypes["default"].string
};
APInlineButton.defaultProps = {
  customClass: 'custom-inline-btn'
};
var _default = exports["default"] = APInlineButton;